export const bravoTabs = [
  {
    id: 1,
    name: 'bravo growth',
    image:
      '/images/home/bravo-tabs/self-reflection-tool-for-your-bussiness.webp',
    tabLogo: '/svg/logos/logo-growth.svg',
    title: 'Smart HR Management and Development',
    description:
      '<p>bravoGROWTH offers detailed personality tests designed to help businesses understand their workforce to facilitate better resource allocation and talent development programs.</p><br/><p>Employees will gain a more profound comprehension of their strengths and potential to conduct timely self-training plans.</p><br/><p>The platform also gives HR the capability to systemize all routines using core HR features. You can easily set up onboarding, keep employee records organized, process payroll, manage leave requests and maintain smooth offboarding.</p>',
    link: '/growth',
    bg: 'growth',
    whiteLogo: '/svg/logos/white-growth.svg',
    isShowButton: true
  },
  {
    id: 2,
    name: 'bravo talent',
    image: '/images/home/bravo-tabs/hiring-only-the-right-talents.webp',
    tabLogo: '/svg/logos/logo-talent.svg',
    title: 'Recruitment and Talent Management',
    description:
      '<p>bravoTALENT frees you from the manual and lengthy recruitment procedure by optimizing every step in your hiring. You can evaluate candidates’ skill and personal experience to match your job with the right one.</p><br/><p>Our advanced ATS system allows you to eliminate bias and increase diversity in hiring using an AI-powered resume parser.</p>',
    link: '/talent',
    bg: 'talent',
    whiteLogo: '/svg/logos/white-talent.svg',
    isShowButton: true
  },
  {
    id: 3,
    name: 'bravo survey',
    image: '/images/home/bravo-tabs/engaging-surveys.webp',
    tabLogo: '/svg/logos/logo-surveys.svg',
    title: 'Surveys and Feedback',
    description:
      '<p>bravoSURVEYS helps keep your employee engagement rate high with slick and constructive surveys. It provides you with a wide range of ready-made templates for your organization’s bespoke needs.</p><br/><p>You can create custom surveys for different sectors, from the HR department to Customer Support and Marketing</p>',
    link: '/surveys',
    bg: 'survey',
    whiteLogo: '/svg/logos/white-surveys.svg',
    isShowButton: true
  },
  {
    id: 4,
    name: 'bravo insights',
    image: '/images/home/bravo-tabs/deep-insights-for-decision-making.webp',
    tabLogo: '/svg/logos/logo-insights.svg',
    title: 'Valuable Insights for Decision Making',
    description:
      '<p>Visualize insights from every aspect of your company by generating dashboards and reports for leaders to drive growth.</p>',
    link: '/pricing',
    bg: 'insight',
    whiteLogo: '/svg/logos/white-insights.svg',
    isShowButton: true
  }
];

export const defaultSelectedTab = bravoTabs[0].name;
